import { VisitorEventGivenTicketsAndBadges } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../../axiosInstances";
import { organiserVisitorsQueryKeys } from "../../query-keys";

export type GetGuestsOfEventOrganiserQuery = {
  onlyInvited?: boolean;
};

const getGuestsOfEventOrganiser = async (
  eventId: string,
  query?: GetGuestsOfEventOrganiserQuery
) => {
  const { data } = await privateAxios.get<VisitorEventGivenTicketsAndBadges[]>(
    `/events/${eventId}/visitors`,
    {
      params: query,
    }
  );
  return data;
};
//getGuestsOfEventOrganiser
export const useGuestsOfEventOrganiserQuery = (
  eventId: string,
  query?: GetGuestsOfEventOrganiserQuery
) => {
  return useQuery({
    queryKey: organiserVisitorsQueryKeys.eventAndQuery(eventId, query),
    queryFn: () => getGuestsOfEventOrganiser(eventId, query),
  });
};

const getVisitorInvitationsForEvent = async (
  eventId: string,
  visitorId: string
) => {
  const { data } =
    await privateAxios.get<VisitorEventGivenTicketsAndBadges | null>(
      `/events/${eventId}/visitors/${visitorId}`
    );
  return data;
};

export const useVisitorInvitationsForEventQuery = (
  eventId: string,
  visitorId: string | null
) => {
  return useQuery({
    enabled: !!visitorId,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- we know that visitorId is not null
    queryKey: organiserVisitorsQueryKeys.eventAndVisitor(eventId, visitorId!),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- we know that visitorId is not null
    queryFn: () => getVisitorInvitationsForEvent(eventId, visitorId!),
  });
};
